import Text from "common/Typography/Text";
import React from "react";
import styled from "styled-components";
import { BasicBotData, BotType, MarginTypes } from "@shared/types";
import { typography } from "@shared/common/Themes/typography";
import { getBotLongShortDisplay } from "@shared/features/bots/utils";
import { translateOptionName } from "@shared/common/i18n/optionNames";

interface MarginDataProps {
  botData: BasicBotData;
}

const MarginData = ({ botData }: MarginDataProps) => {
  const getMarginType = () => {
    if (!botData.margin_type) return null;
    return translateOptionName(
      botData.margin_type === MarginTypes.CROSS ? "Cross" : "Isolated"
    );
  };
  const getLeverage = () => {
    if (!botData.leverage) return null;
    return `${botData.leverage}x`;
  };

  const marginType = getMarginType();
  const leverage = getLeverage();
  const showMarginTypeAndValue = marginType || leverage;
  const isHedgingBot = botData.bot_type === BotType.HEDGING;

  return (
    <Text
      as="div"
      type="secondary"
      $size={typography.fontSizes.S}
      style={{ display: "flex", alignItems: "center" }}
    >
      {!isHedgingBot && <span>{getBotLongShortDisplay(botData)}</span>}
      {showMarginTypeAndValue && (
        <>
          {!isHedgingBot && <Divider />}
          <Text type="secondary" $size={typography.fontSizes.S}>
            {marginType} {leverage}
          </Text>
        </>
      )}
    </Text>
  );
};

export default React.memo(MarginData);

const Divider = styled.div`
  border-right: ${(p) => p.theme.borders.hard};
  margin: 0 8px;
  height: 14px;
`;
